import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapRadioButton = React.lazy(function () { return import('../../bootstrap-components/components/BTRadioButton'); });
var bootStrapRadioButton = function (props) {
    return (React.createElement(BootStrapRadioButton, { name: "RadioButton", checked: props.checked, onChange: props.onChange, onBlur: props.onBlur, styleName: props.styleName, label: props.label, ioTheme: props.ioTheme, ioMode: props.ioMode, style: {}, mandatory: props.mandatory, hasError: props.hasError, errorMessage: props.errorMessage, displayType: props.displayType, options: props.options, configId: props.configId, value: props.value, disabled: props.disabled, isInlineGridComponent: props.isInlineGridComponent, className: props.className }));
};
export var RadioButton = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapRadioButton(props);
            break;
        default:
            componentToDisplay = bootStrapRadioButton(props);
            break;
    }
    return (React.createElement("div", null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
RadioButton.defaultProps = {
    styleName: 'primary',
    label: 'RadioButton',
    ioTheme: themes[0],
    ioMode: 'light',
    options: { 'yes': 'yes', 'no': 'no' },
    isInlineGridComponent: false
};
//# sourceMappingURL=RadioButton.js.map